import { Search } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grievaces-addressing-grid',
  templateUrl: './grievaces-addressing-grid.component.html',
  styleUrls: ['./grievaces-addressing-grid.component.css']
})
export class GrievacesAddressingGridComponent implements OnInit {
  title = "District Grievance List";  
  grievances;  
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  buttoncolorclose: string = "warn";
  buttoncoloropen: string = "primary";
  buttoncolornew: string = "warn";
  select: any;
  message : boolean;
  //buttonType:any="Closed";
  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllGrievancesByDistrict(this.itemsPerPage, 1);
  }


  
  SetUrl(Id:any,mode:any)
  {
    localStorage.setItem('grievanceId',Id);
    localStorage.setItem('mode', mode);
  }


  //Pending
  GetAllGrievancesByDistrict(itemsPerPage: number, pageNo: number) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllGrievancesByDistrict(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.grievances=data.SainikGrievancess;          
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else if(this.select=='both')
       this.Both(pageNumber);
    else
    this.GetAllGrievancesByDistrict(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    if(this.select=='both')
       this.Both(pageNo);
    else
      this.GetAllGrievancesByDistrict(this.itemsPerPage, pageNo);
  }
   //variable : holds the data from API
 // districtList;
 onSearch(s,itemsPerPage: number, pageNo: number) 
 {
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
   else {
     document.getElementById('loader-spinner').style.display = "block";
     this.userService.GetAllGrievancesByDistrictSearch(searchCriteria, searchText, itemsPerPage, pageNo)
       .subscribe(
         (data:any) => {
           this.grievances = data.SainikGrievancess;           
           this.totalItems = data.TotalItemsCount;           
           this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }
 }

 //Both Grievace Actionstatus
 Both(pageNo: number)
 {
   this.select='both';
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getAllGrievancesByDistrictForBoth(this.itemsPerPage,pageNo)
    .subscribe(
      (data:any) => {
        this.grievances=data.SainikGrievancess;          
        this.totalItems=data.TotalItemsCount;
        this.itemsPerPage =this.itemsPerPage;
        this.currentPage= pageNo;          
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });

 }

 Open()
 {
  this.GetAllGrievancesByDistrict(this.itemsPerPage, 1);
 }
}



// WEBPACK FOOTER //
// ./src/app/Grievances-Addressing/grievaces-addressing-grid/grievaces-addressing-grid.component.ts